module.exports = __webpack_public_path__ + "static/media/operador-logo-sodexo.7d657656.svg";